<div class="modal-header border-b border-solid border-base-2 px-6 py-4 no-print">
    <h2 class="modal-title text-title-2 text-text-primary font-semibold" id="print-location-dialog-title">
        {{ 'printLocation' | translate }}
    </h2>
    <button
        type="button"
        class="btn btn-circle btn-ghost element-cancel"
        [attr.aria-label]="'accessibility.close-dialog' | translate"
        (click)="closeDialog()"
    ></button>
</div>
<div class="modal-body px-6 py-5">
    <div class="lay-wrapper">
        <div class="m-content m-content--contact m-content--large" (click)="$event.stopPropagation()">
            <div class="grid-row">
                <div class="grid-row">
                    <div class="divToPrint">
                        <div class="headLine">
                            <div class="columnContainer">
                                <div class="propertyContainer">
                                    <div class="title left-side" translate="locationdata.country">Land</div>
                                    <div class="content">{{ countryName() }}</div>
                                </div>
                            </div>
                            <div class="columnContainer">
                                <div class="propertyContainer">
                                    <div class="title left-side">LKZ2</div>
                                    <div class="content">{{ locationdata().countryIsoCode2 }}</div>
                                </div>
                                <div class="propertyContainer">
                                    <div class="title left-side">LKZ3</div>
                                    <!-- 	                <div class="content">{{ locationdata().countryCode3 }}</div> -->
                                </div>
                            </div>
                            <div class="columnContainer">
                                <div class="propertyContainer">
                                    <div class="title left-side" translate="locationdata.continent"></div>
                                    <div class="content">{{ locationdata().country?.continent }}</div>
                                </div>
                                <div class="propertyContainer">
                                    <div class="title left-side">SAG-Nummer</div>
                                    <div class="content">004</div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div style="display: flex">
                            <div style="flex: 1">
                                <div>
                                    <p class="left-side">{{ 'locationdata.visitingaddress' | translate }}</p>
                                    <p>{{ locationdata().company.name }}</p>
                                    <p>{{ locationdata().address.name }}</p>
                                    <p>{{ locationdata().address.street }}</p>
                                    <p>{{ locationdata().address.province }}</p>
                                    @if (locationdata().zipCodeFirst) {
                                        <p>{{ locationdata().address.city }} {{ locationdata().address.postalCode }}</p>
                                    } @else {
                                        <p>{{ locationdata().address.postalCode }} {{ locationdata().address.city }}</p>
                                    }
                                    <p>{{ countryName() }}</p>
                                    <br />
                                    <br />
                                </div>
                                @if (locationdata().address.poBox) {
                                    <div>
                                        <p class="left-side">{{ 'locationdata.postaladdress' | translate }}</p>
                                        <p>{{ locationdata().address.poBox }}</p>
                                        <div>
                                            @if (locationdata().zipCodeFirst) {
                                                <p>{{ locationdata().address.poBoxCity }}</p>
                                                <p>{{ locationdata().address.poBoxPostalCode }}</p>
                                            } @else {
                                                <p>{{ locationdata().address.poBoxPostalCode }}</p>
                                                <p>{{ locationdata().address.poBoxCity }}</p>
                                            }
                                        </div>
                                        <br />
                                        <div>
                                            <si-icon class="inline-icon" icon="element-location" />
                                            <span>{{ locationdata().gps || 'N/A' }}</span>
                                        </div>
                                        <br />
                                    </div>
                                }
                                <div>
                                    <p class="left-side">{{ 'locationdata.communicationdetails' | translate }}</p>
                                    @for (tel of locationdata().phones; track tel) {
                                        <p style="margin: 10px 0">
                                            <si-icon
                                                class="inline-icon"
                                                icon="element-phone"
                                                title="{{ 'tooltip.symbol.phone' | translate }}"
                                            />
                                            {{ tel.value }}
                                        </p>
                                    }
                                    @for (fax of locationdata().faxes; track fax) {
                                        <p style="margin: 10px 0">
                                            <si-icon
                                                class="inline-icon"
                                                icon="element-print"
                                                title="{{ 'tooltip.symbol.fax' | translate }}"
                                            />
                                            {{ fax.value }}
                                        </p>
                                    }
                                    @for (url of locationdata().websiteUrls; track url) {
                                        <p style="margin: 10px 0">
                                            <si-icon
                                                class="inline-icon"
                                                icon="element-link"
                                                title="{{ 'tooltip.symbol.globe' | translate }}"
                                            />
                                            <a href="{{ url.value }}" target="_blank" rel="noopener noreferrer">{{
                                                url.description || url.value
                                            }}</a>
                                        </p>
                                    }
                                    <br />
                                    <br />
                                </div>
                            </div>
                            <div style="flex: 1">
                                <div style="flex: 2">
                                    <div style="display: flex">
                                        <div class="left-side left-side--one">SALID</div>
                                        <div class="right-side right-side--one">{{ locationdata().salId }}</div>
                                    </div>
                                    <div style="display: flex">
                                        <div class="left-side left-side--one">
                                            {{ 'locationdata.companyshort' | translate }}
                                        </div>
                                        <div class="right-side right-side--one">
                                            {{ locationdata().company.nameShort }}
                                        </div>
                                    </div>
                                    @if (locationdata().address.campus) {
                                        <div style="display: flex">
                                            <div class="left-side left-side--one">
                                                {{ 'locationdata.campus' | translate }}
                                            </div>
                                            <div class="right-side right-side--one">
                                                {{ locationdata().address.campus }}
                                            </div>
                                        </div>
                                    }
                                    <div style="display: flex">
                                        <div class="left-side left-side--one">
                                            {{ 'locationdata.locationshort' | translate }}
                                        </div>
                                        <div class="right-side right-side--one">
                                            {{ locationdata().locationCode }}
                                        </div>
                                    </div>
                                    @if (locationdata().address && locationdata().address.building) {
                                        <div style="display: flex">
                                            <div class="left-side left-side--one">
                                                {{ 'locationdata.building' | translate }}
                                            </div>
                                            <div class="right-side right-side--one">
                                                {{ locationdata().address.building }}
                                            </div>
                                        </div>
                                    }
                                    @if (locationdata().address && locationdata().address.floor) {
                                        <div style="display: flex">
                                            <div class="left-side left-side--one">
                                                {{ 'locationdata.floor' | translate }}
                                            </div>
                                        </div>
                                    }
                                    @if (locationdata().address && locationdata().address.suite) {
                                        <div style="display: flex">
                                            <div class="left-side left-side--one">
                                                {{ 'locationdata.suite' | translate }}
                                            </div>
                                        </div>
                                    }
                                    <div style="display: flex">
                                        <div class="left-side left-side--one">
                                            {{ 'locationdata.buildings' | translate }}
                                        </div>
                                        <div class="right-side right-side--one">{{ buildings() }}</div>
                                    </div>
                                    <br />
                                    <br />
                                    <div style="display: flex">
                                        <div class="left-side left-side--one">
                                            {{ 'locationdata.communenumber' | translate }}
                                        </div>
                                        <div class="right-side right-side--one">
                                            {{ locationdata().communeNumber }}
                                        </div>
                                    </div>
                                    <br />
                                    <br />
                                    <div style="display: flex">
                                        <div class="left-side left-side--one">
                                            {{ 'locationdata.corporateType' | translate }}
                                        </div>
                                        <div class="right-side right-side--one">
                                            {{ locationdata().company.corporateType }}
                                        </div>
                                    </div>
                                    <div style="display: flex">
                                        <div class="left-side left-side--one">
                                            {{ 'locationdata.businessactivity' | translate }}
                                        </div>
                                        <div class="right-side right-side--one">
                                            {{ locationdata().company.companyType }}
                                        </div>
                                    </div>
                                    @if (locationdata().company.companyTypeComment) {
                                        <div style="display: flex">
                                            <div class="left-side left-side--one">
                                                {{ 'locationdata.comment' | translate }}
                                            </div>
                                            <div class="right-side right-side--one">
                                                {{ locationdata().company.companyTypeComment }}
                                            </div>
                                        </div>
                                    }
                                    <br />
                                    <br />
                                    <div style="display: flex">
                                        <div class="left-side left-side--one">
                                            {{ 'locationdata.divisions' | translate }}
                                        </div>
                                        <div class="right-side right-side--one">
                                            {{ locationdata().company.divisions }}
                                        </div>
                                    </div>
                                    <br />
                                    <br />
                                    <div style="display: flex">
                                        <div class="left-side left-side--one">{{ 'locationdata.are' | translate }}</div>
                                        <div class="right-side right-side--one">
                                            {{ locationdata().company.are }}
                                        </div>
                                    </div>
                                    <div style="display: flex">
                                        <div class="left-side left-side--one">
                                            {{ 'locationdata.managingAre' | translate }}
                                        </div>
                                        <div class="right-side right-side--one">
                                            {{ locationdata().company.managingAre }}
                                        </div>
                                    </div>
                                    <div style="display: flex">
                                        <div class="left-side left-side--one">
                                            {{ 'locationdata.client' | translate }}
                                        </div>
                                        <div class="right-side right-side--one">
                                            {{ locationdata().company.client }}
                                        </div>
                                    </div>
                                    <div style="display: flex">
                                        <div class="left-side left-side--one">
                                            {{ 'locationdata.groupshare' | translate }}
                                        </div>
                                        <div class="right-side right-side--one">
                                            {{ locationdata().company.companyShare }}%
                                        </div>
                                    </div>
                                </div>
                                <div class="right-side right-side--one">{{ locationdata().lastModifiedDate }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-actions no-print border-t border-solid border-base-2 px-6 py-3">
    <button
        type="button"
        class="btn btn-primary"
        [attr.aria-label]="'accessibility.close' | translate"
        (click)="closeDialog()"
    >
        {{ 'close' | translate }}
    </button>
    <button
        type="button"
        class="btn btn-primary"
        [attr.aria-label]="'accessibility.print' | translate"
        (click)="print()"
    >
        {{ 'app.print' | translate }}
    </button>
</div>
